<template>
  <svg class="vue-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 10">
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.064"
        y1="1"
        x2="1"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#222565" />
        <stop offset="1" stop-color="#122e95" />
      </linearGradient>
    </defs>
    <path
      id="Logo-visa"
      d="M14.62,9.591c-.452-.157-1.269-.572-1.26-.867l.045-1.985.644.482c1.516,1.048,4.263,1.257,4.31.041.033-.86-1.122-1.413-1.929-1.77l-.268-.118a2.352,2.352,0,0,1-1.627-2.115c-.1-2.824,3.651-3.6,5.858-3.131a5.654,5.654,0,0,1,1.836.824L21.847,2.9l-.079.007a4.463,4.463,0,0,0-2.153-1.017c-1.326-.2-2.1.264-2.083.835.014.411.359.678,1.152,1.167q1.314.81,1.425.893,2.457,1.838.3,3.984A4.745,4.745,0,0,1,17.014,10,7.391,7.391,0,0,1,14.62,9.591ZM1.33,9.614l-.024-7.68a1.474,1.474,0,0,0-.33-.64A2.614,2.614,0,0,0,.413.745C.188.577.05.469,0,.42H4.292l.025,6.038a.068.068,0,0,1,.052.012L8.32.7,8.26.4l2.929.006L4.442,9.636ZM26.268.609,26.3.375l3.028,0,.588,8.6.08.589-2.927.011a2.521,2.521,0,0,0,.059-.772q-.053-1.5-.052-1.564l-2.694.043L23.249,9.033a.649.649,0,0,0,.034.541l-2.706.008Zm-.921,5.12,1.544,0,0-.032-.171-2.176ZM8.743,8.95,11.61,1.085A1.351,1.351,0,0,0,11.7.373c.012,0,.018-.008.018-.017l3.451.009,0,.032-.184.192L11.828,9.042q-.14.386,0,.534l-3.489,0A1.366,1.366,0,0,0,8.743,8.95Z"
      fill="url(#linear-gradient)"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconLogoVisa',
};
</script>
